export default {
    title: "FAQ",
    disclaimer: "N.B.: The information on this page are subject to change.",
    subjects: [
        {
            topic: "Can I sleep at ITU?",
            id: "sleep",
            paragraphs: [
                "There is no sleeping accommodations at ITU LAN. This is because of a strict fire code set for the building. We recommend going home and sleep there. We provide free storage for your gear in the meantime.",
            ],
        },
        {
            topic: "Where and when is the LAN?",
            id: "where",
            paragraphs: [
                "ITU LAN Spring 2026 takes place from April the  24th to the 26th at the IT University of Copenhagen."
                // "Stay tuned for announcement of the next LAN.",
            ],
        },
        {
            topic: "Alcohol",
            id: "Alcohol",
            paragraphs: [
                "Alcohol consumption is prohibited above the ground floor as per ITU policy. People with open cups, e.g., ScrollBar cups, at LAN premises will be asked to move to ScrollBar, Atrium or the outdoor areas to protect the participants' personal belongings such as desktop computers."
            ],
        },
        {
            topic: "Can I buy drinks in ScrollBar?",
            id: "scrollbar",
            paragraphs: [
                "Yes - ScrollBar is open Friday 15.00-02.00 and is well-stocked with beers, soda, drinks, RedBull, etc. at student-friendly prices.",
                "Please note that alcoholic beverages can only be enjoyed in the ScrollBar area, and you have to be 18 years of age to buy them.",
                "Please drink responsibly.",
            ],
        },
        {
            topic: "How do I get in?",
            id: "getting-in",
            paragraphs: [
                "You can get in through the various entrances in the building. We've coordinated with facilities management, that you can get in with either a valid student ID or with an ITU LAN ticket. Please have it ready upon entry.",
                "You get your wristband to use for access at the checkin area (1st floor).",
            ],
        },
        {
            topic: "Where can I park my car?",
            id: "parking",
            paragraphs: [
                "There's a parking lot on the east side of ITU. If you're affiliated with ITU, you can get a parking permit at the information desk by the main entrance. You have to pay a deposit of 300 DKK for the permit and you should get it before arriving at LAN.",
                "If you're not affiliated with ITU, you can use the parking meter at the parking lot, or find another place to park. ITU LAN is not taking any responsibility for any parking charges.",
            ],
        },
        {
            topic: "How do I contact the crew?",
            id: "contact",
            paragraphs: [
                "Before LAN, the best way to contact us if you have any questions related to LAN is through our Discord page, which you can find <a target='_blank' rel='noopener' href='https://discord.gg/nSFXWQN'>here<a>.",
                "During the LAN, the primary platform for contact is our Discord server - join it <a target='_blank' rel='noopener' href='https://discord.gg/nSFXWQN'>here</a>! Here you can contact us directly, ask game- or event-specific questions, and get updates on the different tournaments.",
                "If you need in-person help during the LAN, swing by the checkin area on the 1st floor or the crew area located at the checkin area, most crew members are wearing blue tshirt with ITU-lan print.",
            ],
        },
        {
            topic: "How do I find my table?",
            id: "table",
            paragraphs: [
                "You have chosen your table and seat during the booking process. The table number from your booking is final. Ignore any other table numbers, than the ones posted on ITU LAN posters on the tables.",
            ],
        },
        {
            topic: "Where do I find information about tournaments? ",
            id: "tournaments",
            paragraphs: [
                "For info or support please contact the tournament responsible, which can be seen on the tournament's Toornament page, or by writing in the tournament's <a target='_blank' rel='noopener' href='https://discord.gg/nSFXWQN'>Discord</a>-channel.",
                "Deadlines for sign-up for tournaments and events can be found at the Toornament-page for each tournament. See the <a href='/tournaments'>Tournament</a> page for more info.",
            ],
        },
        {
            topic: "Do you provide food and drinks?",
            id: "free-food",
            paragraphs: [
                "No - you have to stock yourself up with food, but there are several supermarkets around.",
                "Usually our sponsors will provide a limited amount of drinks during the LAN, but is not always guaranteed.",
                "You can, however, order food online. Order your food to: <br> <b>IT-Universitetet i København</><br><b>Rued Langgaardsvej 7</b><br><b>2300 København S</b>",
            ],
        },
        {
            topic: "Are there any facilities to prepare my own food?",
            id: "kitchens",
            paragraphs: [
                "Yes - you can bring your own food and heat it up in the kitchen on each floor. There are refrigerators and microwave ovens.",
            ],
        },

        {
            topic: "Did you say storage?",
            id: "storage",
            paragraphs: [
                "Yes - there will be storage on each floor in 2A12-14, 3A12-14, and 4A12-14",
                "If you need to store or pickup your gear please contact the crew at the checkin area (1st floor) or write @keywarden on <a href='https://discord.gg/nSFXWQN' target='_blank' rel='noopener'>our Discord channel</a>.",
            ],
        },
    ],
}